import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
import { isNullOrUndefined } from "util";
/* eslint-disable */
const state = {
  options: null,
  planOptions: null,
  planIdentity: null,
  // cmsEnums: null
  baseUrl: "cms/",
  baseOdataUrl: "cms/odata/",
  baseOdataUrlMember: null,
};

const getters = {
  options: (state) => {
    return state.options;
  },
  baseUrl: (state) => {
    return state.baseUrl;
  },
  baseOdataUrl: (state) => {
    return state.baseOdataUrl;
  },
  baseOdataUrlMember: (state) => {
    return state.baseOdataUrlMember;
  },
  // cmsEnums: (state) => {
  //     return state.cmsEnums
  // }
};

const actions = {
  setBaseUrl({ state }, url) {
    state.baseUrl = url;
  },
  setBaseOdataUrl({ state }, url) {
    state.baseOdataUrl = url;
  },
  setBaseOdataUrlMember({ state }, url) {
    state.baseOdataUrlMember = url;
  },
  async saveCategory({ commit }, category) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "cms/odata/DownloadCenterCategories" +
      (category.Id ? `/${category.Id}` : "");
    if (!category.Id) {
      return (await ApiService.post(url, category)).data;
    } else {
      return (await ApiService.put(url, category)).data;
    }
  },
  async deleteCategory({ commit }, category) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "cms/odata/DownloadCenterCategories/" + category.Id;
    return (await ApiService.delete(url)).data;
  },
  async saveFile({ commit }, file) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "cms/odata/DownloadCenterFiles" +
      (file.Id ? `/${file.Id}` : "");
    if (!file.Id) {
      return (await ApiService.post(url, file)).data;
    } else {
      return (await ApiService.put(url, file)).data;
    }
  },
  async deleteFile({ commit }, file) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/DownloadCenterFiles/" + file.Id;
    return (await ApiService.delete(url)).data;
  },

  async getThemeSettings({ commit }, planId) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${planId})/ThemeSettings?$expand=ImageSettings($expand=ImageSettingsTranslations($expand=PageTitleIcon($expand=PhysicalFile($select=Path,Id)),Banner($expand=PhysicalFile($select=Path,Id)),Logo($expand=PhysicalFile($select=Path,Id))))`;
    return (await ApiService.get(url)).data;
  },

  async saveThemeSettings({ commit }, colors) {
    if (
      colors.ImageSettings &&
      colors.ImageSettings.ImageSettingsTranslations
    ) {
      for (var i of colors.ImageSettings.ImageSettingsTranslations) {
        delete i.LanguageName;
      }
    }
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "cms/odata/ThemeSettings" +
      (colors.Id ? `/${colors.Id}` : "");

    if (!colors.Id) {
      return (await ApiService.post(url, colors)).data;
    } else {
      return (await ApiService.put(url, colors)).data;
    }
  },

  async getIcons({ commit }, { planId, page }) {
    //console.log(arguments);
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${planId})/Icons?$skip=${
        (page - 1) * 30
      }&$top=30&$count=true`;
    return (await ApiService.get(url)).data;
  },

  async saveIcon({ commit }, icon) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/Icons";
    if (!icon.Id) {
      return (await ApiService.post(url, icon)).data;
    } else {
      return (await ApiService.put(url, icon)).data;
    }
  },

  async deleteIcon({ commit }, icon) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/Icons/" + icon.Id;
    return (await ApiService.delete(url)).data;
  },

  async getImages({ commit }, planId) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${planId})/Images?$expand=PhysicalFile`;
    return (await ApiService.get(url)).data;
  },

  async saveImage({ commit }, icon) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/Images";
    if (!icon.Id) {
      return (await ApiService.post(url, icon)).data;
    } else {
      return (await ApiService.put(url, icon)).data;
    }
  },

  async deleteImage({ commit }, icon) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/Images/" + icon.Id;
    return (await ApiService.delete(url)).data;
  },

  // async getSidebarItems({ commit }, planId) {
  //     var settings = SettingsService.settings
  //     const url = settings.APIURL + "cms/odata/SidebarItems/" + planId
  //     return (await ApiService.get(url)).data;
  // },

  async importDrugs({ commit }, { base64, name, planId, memberGroupIdentityIds }) {
    const file = actions.dataURLtoFile(base64, name);
    const data = new FormData();
    data.append("file", file, file.name);
    data.append("planId", planId);
    if (memberGroupIdentityIds!==null && memberGroupIdentityIds!== undefined) {
      data.append("memberGroupIdentityIds", memberGroupIdentityIds);
    }

    return (await ApiService.postFile(state.baseUrl + "Drugs/Import", data))
      .data;
  },

  async saveDrug({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + state.baseOdataUrl + "Drugs";
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + state.baseOdataUrl + "Drugs/" + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },

  async saveProviderService({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + state.baseOdataUrl + "ProviderServices";
      return (await ApiService.post(url, item)).data;
    } else {
      const url =
        settings.APIURL + state.baseOdataUrl + "ProviderServices/" + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },

  async saveProvider({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + state.baseOdataUrl + "Providers";
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + state.baseOdataUrl + "Providers/" + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },

  async saveDrugsInfo({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + `cms/odata/DrugsInfo`;
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + `cms/odata/DrugsInfo/` + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },
  async saveProvidersInfo({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + `cms/odata/ProvidersInfo`;
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + `cms/odata/ProvidersInfo/` + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },
  async getProvidersInfo({ commit }, planId) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${planId})/ProvidersInfo?$expand=Translations($select=Id,Html,Title,LanguageCode)`;
    return (await ApiService.get(url)).data;
  },
  async getDrugsInfo({ commit }, planId) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${planId})/DrugsInfo?$expand=Translations($expand=Image($expand=PhysicalFile);$select=Id,Html,Title,LanguageCode,ImageId)`;
    return (await ApiService.get(url)).data;
  },

  async deleteDrug({ commit }, item) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + state.baseOdataUrl + "Drugs/" + item.Id;
    return (await ApiService.delete(url)).data;
  },

  async saveCoverageInfo({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + `cms/odata/CoverageTilesInfo`;
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + `cms/odata/CoverageTilesInfo/` + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },

  async getCoverageInfo({ commit }, planId) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${planId})/CoverageTilesInfo?$expand=Translations($select=Id,Html,Title,LanguageCode)`;
    return (await ApiService.get(url)).data;
  },

  async deleteProviderService({ commit }, item) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + state.baseOdataUrl + "ProviderServices/" + item.Id;
    return (await ApiService.delete(url)).data;
  },

  async deleteProvider({ commit }, item) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + state.baseOdataUrl + "Providers/" + item.Id;
    return (await ApiService.delete(url)).data;
  },

  async saveSidebarItem({ commit }, sidebarItem) {
    var settings = SettingsService.settings;
    if (!sidebarItem.Id) {
      const url = settings.APIURL + "cms/odata/SidebarItems";
      return (await ApiService.post(url, sidebarItem)).data;
    } else {
      const url = settings.APIURL + "cms/odata/SidebarItems/" + sidebarItem.Id;
      return (await ApiService.put(url, sidebarItem)).data;
    }
  },
  async deleteSidebarItem({ commit }, sidebarItem) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/SidebarItems/" + sidebarItem.Id;
    return (await ApiService.delete(url)).data;
  },

  async uploadFile({ commit }, { base64, name }) {
    const file = actions.dataURLtoFile(base64, name);
    const data = new FormData();
    data.append("file", file, file.name);

    return (await ApiService.postFile("cms/PhysicalFile/Upload", data)).data;
  },

  async saveNews({ commit }, { planId, news }) {
    var settings = SettingsService.settings;
    if (!news.Id) {
      const url = settings.APIURL + `cms/odata/NewsItems`;
      return (await ApiService.post(url, news)).data;
    } else {
      const url = settings.APIURL + `cms/odata/NewsItems/${news.Id}`;
      return (await ApiService.put(url, news)).data;
    }
  },
  async deleteNews({ commit }, news) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/NewsItems/" + news.Id;
    return (await ApiService.delete(url)).data;
  },
  async saveNewsSettings({ commit }, { planId, newsSettings }) {
    var settings = SettingsService.settings;
    if (!newsSettings.Id) {
      const url = settings.APIURL + `cms/odata/NewsSettings`;
      return (await ApiService.post(url, newsSettings)).data;
    } else {
      const url = settings.APIURL + `cms/odata/NewsSettings/${newsSettings.Id}`;
      return (await ApiService.put(url, newsSettings)).data;
    }
  },
  async getNewsSettings({ commit }, planId) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + `cms/odata/Plans(${planId})/NewsSettings`;
    return (await ApiService.get(url)).data;
  },
  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n) {
      u8arr[n - 1] = bstr.charCodeAt(n - 1);
      n -= 1; // to make eslint happy
    }
    return new File([u8arr], filename, { type: mime });
  },
  // async getCmsEnums({ state, cmsEnums }){
  //     // var settings = SettingsService.settings
  //     // const url = settings.APIURL + "cms/Enums";
  //     // let cmsEnums = (await ApiService.get(url)).data
  //     state.cmsEnums = cmsEnums;
  // },

  async savePage({ commit }, { planId, page }) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + `cms/odata/Pages/${page.Id}`;
    return (await ApiService.put(url, page)).data;
  },
  async createPortalPages({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + `cms/CreatePortalPages/${options.planIdentityId}`;
    return (await ApiService.post(url)).data;
  },

  async saveNotification({ commit }, { planId, popup }) {
    var settings = SettingsService.settings;
    if (!popup.Id) {
      const url = settings.APIURL + `cms/odata/Popups`;
      return (await ApiService.post(url, popup)).data;
    } else {
      const url = settings.APIURL + `cms/odata/Popups/${popup.Id}`;
      return (await ApiService.put(url, popup)).data;
    }
  },

  async deleteNotification({ commit }, popup) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + `cms/odata/Popups/${popup}`;
    return (await ApiService.delete(url)).data;
  },

  async saveContact({ commit }, { planId, contact }) {
    var settings = SettingsService.settings;
    if (!contact.Id) {
      const url = settings.APIURL + `cms/odata/Contacts`;
      return (await ApiService.post(url, contact)).data;
    } else {
      const url = settings.APIURL + `cms/odata/Contacts/${contact.Id}`;
      return (await ApiService.put(url, contact)).data;
    }
  },
  async deleteContact({ commit }, { planId, id }) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/Contacts/" + id;
    return (await ApiService.delete(url)).data;
  },
  async saveBenefitCard({ state }, { planId, card }) {
    var settings = SettingsService.settings;
    if (!card.Id) {
      const url = settings.APIURL + state.baseOdataUrl + "BenefitCards";
      return (await ApiService.post(url, card)).data;
    } else {
      const url =
        settings.APIURL + state.baseOdataUrl + "BenefitCards/" + card.Id;
      return (await ApiService.put(url, card)).data;
    }
  },
  async getBenefitCard({ commit }, { planId, id }) {
    var settings = SettingsService.settings;

    const url = settings.APIURL + state.baseOdataUrl + `BenefitCards(${id})`;
    return (await ApiService.get(url)).data;
  },

  async getBenefitCardImage({ commit }, options) {
    var settings = SettingsService.settings;

    const url =
      settings.APIURL + state.baseUrl + `BenefitCards/${options.language}`;
    return (await ApiService.post(url, options.args)).data;
  },

  async deleteBenefitCard({ commit }, { planId, id }) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + state.baseOdataUrl + "BenefitCards/" + id;
    return (await ApiService.delete(url)).data;
  },
  async saveCoverageTile({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + "cms/odata/CoverageTiles";
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + "cms/odata/CoverageTiles/" + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },
  async deleteCoverageTile({ commit }, item) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/CoverageTiles/" + item.Id;
    return (await ApiService.delete(url)).data;
  },

  async saveCoverageTileItem({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = settings.APIURL + "cms/odata/CoverageTileItems";
      return (await ApiService.post(url, item)).data;
    } else {
      const url = settings.APIURL + "cms/odata/CoverageTileItems/" + item.Id;
      return (await ApiService.put(url, item)).data;
    }
  },
  async deleteCoverageTileItem({ commit }, item) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "cms/odata/CoverageTileItems/" + item.Id;
    return (await ApiService.delete(url)).data;
  },
  async getPlanWelcomeKit({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/Plans(${options.planIdentityId})/WelcomeKits`;
    return (await ApiService.get(url)).data;
  },
  async getPlanWelcomeKitNew({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/plans/${options.planIdentityId}/WelcomeKits`;
    return (await ApiService.get(url)).data;
  },
  async getWelcomeKitImages({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      `cms/odata/WelcomeKits(${options.welcomeKitId})/WelcomeKitImages?$orderby=Order asc`;
    return (await ApiService.get(url)).data;
  },
  async saveWelcomeKit({ commit }, options) {
    var settings = SettingsService.settings;
    const item = options.payload;
    const url =
      settings.APIURL + `cms/plans/${options.planIdentityId}/WelcomeKits`;
    if (!item.Id) {
      return (await ApiService.post(url, item)).data;
    } else {
      return (await ApiService.put(url + "/" + item.Id, item)).data;
    }
  },
  async deleteWelcomeKit({ commit }, options) {
    var settings = SettingsService.settings;
    const item = options.payload;
    const url =
      settings.APIURL +
      `cms/plans/${options.planIdentityId}/WelcomeKits/${options.payload.Id}`;
    return (await ApiService.delete(url)).data;
  },
  async sendTestWelcomeKit({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + `plans/${options.planIdentityId}/send-test-welcome-kit`;
    return ApiService.post(url, options.payload);
  },
  async getMemberBenefitCards({ commit }, options) {
    var settings = SettingsService.settings;

    const url =
      settings.APIURL +
      state.baseOdataUrlMember +
      `BenefitCards${options.odataQuery}`;
    return ApiService.get(url);
  },
};
const mutations = {};
export const downloadCenter = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
